export default __webpack_public_path__ + "static/media/jpg.a6bcd82b.png";